<template>
    <va-edit-layout>
        <SolutionProviderCreditEvent-form
            :id="id"
            :title="title"
            :item="item"
        ></SolutionProviderCreditEvent-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
